<template>
  <div style="background: #1f1c1f;">
    <div class="header" >
      <div class="header_content">
        <div class="header_left">
          <div v-if="!hasToken" @click="toLogin('/Register')" class="register-btn">{{$t("auth.register")}}</div>
          <div v-else></div>
        </div>
        
        <div class="header_center">
          <div class="filter-trigger" @click="toggleLocationMenu">
            <div class="img_c">
              {{$t("q30")}}
            </div>
            <span class="filter-trigger-arrow" :class="{ 'arrow-open': showLocationMenu }"></span>
          </div>
        </div>
        
        <div class="header_right">
          <div class="location-select">
            <div class="selected-location">
              <img src="/img/location-icon.png" class="location-icon" alt="location" />
              <span class="selected-location-text">{{ selectedLocationLabel }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="location-menu" :class="{ 'location-menu-open': showLocationMenu }">
      <div class="location-item-container">
        <div class="filter_section">
          <div class="filter_label">{{ $t("choose.gender") }}</div>
          <div class="filter_tab_group">
            <button
              v-for="gender in genderOptions"
              :key="gender.value"
              type="button"
              class="filter_tab"
              :class="{ active: selectedGender === gender.value }"
              @click="selectedGender = gender.value"
            >
              {{ gender.label }}
            </button>
          </div>
        </div>

        <div class="filter_section">
          <div class="filter_label">{{ $t("choose.age") }}</div>
          <div class="age_range_box">
            <div class="age_value">{{ minSelectedAge }}</div>
            <div class="age_slider_box">
              <div class="age_slider_track"></div>
              <div class="age_slider_active" :style="ageTrackStyle"></div>
              <input
                v-model.number="minSelectedAge"
                class="age_range_input age_range_input_min"
                type="range"
                min="18"
                max="45"
                @input="handleMinAgeInput"
              />
              <input
                v-model.number="maxSelectedAge"
                class="age_range_input age_range_input_max"
                type="range"
                min="18"
                max="45"
                @input="handleMaxAgeInput"
              />
            </div>
            <div class="age_value">{{ maxSelectedAge }}</div>
          </div>
        </div>

        <div class="filter_section">
          <div class="filter_label">{{ $t("choose.nearbyDistance") }}</div>
          <div class="filter_tab_group distance_tab_group">
            <button
              v-for="distance in distanceOptions"
              :key="distance"
              type="button"
              class="filter_tab distance_tab"
              :class="{ active: selectedDistance === distance }"
              @click="selectedDistance = distance"
            >
              {{ distance }}
            </button>
          </div>
        </div>

        <div class="filter_section">
          <div class="filter_label">{{ $t("choose.nationality") }}</div>
          <div class="filter_select_box">
            <select v-model="selectedCountry" class="filter_select">
              <option
                v-for="country in localizedCountryOptions"
                :key="country.value"
                :value="country.value"
              >
                {{ country.label }}
              </option>
            </select>
          </div>
        </div>

        <div class="filter_actions">
          <button
            type="button"
            class="filter_action_button reset_button"
            @click="resetFilters"
          >
            {{ $t("choose.reset") }}
          </button>
          <button
            type="button"
            class="filter_action_button search_button"
            @click="handleSearchClick"
          >
            {{ $t("choose.search") }}
          </button>
        </div>
      </div>
    </div>
    
    <div class="tu_list">
      <div class="reserve-bg" v-for="item in datalist" :key="item.id">
        <div class="content-bg" @click="handleLockedCardClick">
          <div class="card_blur_layer">
            <div class="corner_tag">{{$t("index.verified")}}</div>
            <div class="img-container">
              <img :src="item.img_url" class="item_img">
            </div>
            <div class="info_box">
              <div class="name_box">
                <span class="name">{{ item.xuanfei_name }}</span>
                <span class="location">{{$t("index.seoul")}}</span>
              </div>
              <div class="stats">
                <div class="stat_item">
                  <img src="/img/neww/icon_views.png" class="icon">
                  <span class="stat_num">{{item.chakan}}</span>
                </div>
                <div class="stat_item">
                  <img src="/img/neww/icon_love.png" class="icon">
                  <span class="stat_num">{{item.dianzan}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card_lock_overlay" aria-hidden="true">
            <div class="card_lock_icon">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M17 9h-1V7a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 1 1 4 0v2h-4V7Zm2 9.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z" fill="currentColor" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showActivationPopup"
      class="activation_popup_mask"
      @click.self="closeActivationPopup"
    >
      <div class="activation_popup">
        <div class="activation_popup_icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M17 9h-1V7a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 1 1 4 0v2h-4V7Zm2 9.75a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z" fill="currentColor" />
          </svg>
        </div>
        <div class="activation_popup_title">
          {{ $t(currentPopupTitleKey) }}
        </div>
        <div class="activation_popup_message">
          {{ $t(currentPopupMessageKey) }}
        </div>
        <div class="activation_popup_actions">
          <button
            type="button"
            class="activation_popup_button"
            @click="closeActivationPopup"
          >
            {{ $t("setting.ok") }}
          </button>
        </div>
      </div>
    </div>
    <!-- <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
          <div  class="imgBox">
            <div
              
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span ><i>{{$t("concubine.high_end")}}</i></span>
          </div>
          <div  style="width: calc(100% - 140px);">
            <div  class="top">
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span >{{$t("index.authentication")}}</span>
              </div>
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span >{{$t("index.video_authentication")}}</span>
              </div>
              <div
                
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
               {{ item.xuanfei_name }}
              </div>
            </div>
            <div  class="tags">
              <van-tag
        v-for="(tag, index) in item.flagArray"
        :key="index"
        :type="tagTypes[index]"
      >
        {{ tag }}
      </van-tag>
              
            </div>
            <div  style="display: flex; align-items: center;">
              <span
                
                style="font-size: 14px; color: rgb(102, 102, 102);"
                >{{$t("index.toll")}}：</span
              >
              <van-rate v-model="item.number"   color="#ffd21e" size="20px" />
            </div>
            <div
              
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
            {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>
            <div  class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div
      style="
        background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139));
        width: 96%;
        margin: 0px auto 30px;
        border-radius: 8px;
        overflow: hidden;
        padding-bottom: 10px;
      "
    >
      <div
        style="
          color: rgb(255, 232, 105);
          text-align: center;
          padding: 10px 0px;
        "
      >
        當前 1590 人在線匹配
      </div>
      <div class="OnlineMatching">
   
        <div
          :style="{
            transform: `translate(0px, ${translateY}px)`,
            transition: 'transform 1s ease-in',
          }"
          ref="scrollContainer"
        >
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
const COUNTRY_OPTION_KEYS = [
  "china",
  "southKorea",
  "japan",
  "singapore",
  "thailand",
  "vietnam",
  "malaysia",
  "taiwan",
  "hongKong",
  "macau",
  "philippines",
  "indonesia",
  "unitedStates",
  "canada",
  "australia",
  "unitedKingdom",
  "france",
  "germany",
  "italy",
  "russia",
  "india"
];

const {
  GEO_LOCATION_CACHE_KEY,
  getCountryTranslationKey,
} = require("../../utils/location");

export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      hotCities: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning'],
      showLocationMenu: false,
      selectedGender: 'all',
      minSelectedAge: 18,
      maxSelectedAge: 45,
      distanceOptions: ['5km', '10km', '25km', '50km', '100+km'],
      selectedDistance: '5km',
      selectedCountry: 'all',
      currentUserCountryKey: '',
      currentUserCountryName: '',
      showActivationPopup: false,
      currentPopupTitleKey: 'index.activationRequiredTitle',
      currentPopupMessageKey: 'index.activationRequiredMessage'
    };
  },
  computed: {
    // 根据当前语言显示"全部"文本
    allRegionsText() {
      return this.$t('index.all_regions');
    },
    genderOptions() {
      return [
        { value: 'all', label: this.$t('index.all') },
        { value: 'female', label: this.$t('choose.female') },
        { value: 'male', label: this.$t('choose.male') }
      ];
    },
    localizedCountryOptions() {
      return [
        {
          value: 'all',
          label: this.allRegionsText
        },
        ...COUNTRY_OPTION_KEYS.map((countryKey) => ({
          value: countryKey,
          label: this.$t(`choose.countries.${countryKey}`)
        }))
      ];
    },
    selectedLocationLabel() {
      if (this.currentUserCountryKey) {
        return this.$t(`choose.countries.${this.currentUserCountryKey}`);
      }

      if (this.currentUserCountryName) {
        return this.currentUserCountryName;
      }

      return this.$t("index.region");
    },
    ageTrackStyle() {
      const min = 18;
      const max = 45;
      const start = ((this.minSelectedAge - min) / (max - min)) * 100;
      const end = ((this.maxSelectedAge - min) / (max - min)) * 100;

      return {
        left: `${start}%`,
        width: `${end - start}%`
      };
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData,"309");
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, "Hot Lottery Data");
        if (res.data && Array.isArray(res.data)) {
          this.hotCities = res.data;
        }
      });
    },
    getBanner(data){
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    getNotice(data){
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    handleLockedCardClick() {
      this.openActivationPopup('index.activationRequiredMessage');
    },
    handleSearchClick() {
      this.openActivationPopup('choose.searchActivationMessage', 'choose.searchActivationTitle');
    },
    openActivationPopup(messageKey, titleKey = 'index.activationRequiredTitle') {
      this.currentPopupTitleKey = titleKey;
      this.currentPopupMessageKey = messageKey;
      this.showActivationPopup = true;
    },
    closeActivationPopup() {
      this.showActivationPopup = false;
    },
    handleMinAgeInput() {
      if (this.minSelectedAge > this.maxSelectedAge) {
        this.minSelectedAge = this.maxSelectedAge;
      }
    },
    handleMaxAgeInput() {
      if (this.maxSelectedAge < this.minSelectedAge) {
        this.maxSelectedAge = this.minSelectedAge;
      }
    },
    resetFilters() {
      this.selectedGender = 'all';
      this.minSelectedAge = 18;
      this.maxSelectedAge = 45;
      this.selectedDistance = this.distanceOptions[0];
      this.selectedCountry = 'all';
    },
    restoreCachedCountry() {
      try {
        const cachedLocation = localStorage.getItem(GEO_LOCATION_CACHE_KEY);

        if (!cachedLocation) {
          return;
        }

        const parsedLocation = JSON.parse(cachedLocation);
        const isExpired = !parsedLocation.expiresAt || parsedLocation.expiresAt < Date.now();

        if (isExpired) {
          localStorage.removeItem(GEO_LOCATION_CACHE_KEY);
          return;
        }

        this.currentUserCountryName = parsedLocation.country || "";
        this.currentUserCountryKey =
          parsedLocation.countryKey || getCountryTranslationKey(parsedLocation.country);

        if (this.currentUserCountryKey) {
          this.selectedCountry = this.currentUserCountryKey;
        }
      } catch (error) {
        localStorage.removeItem(GEO_LOCATION_CACHE_KEY);
      }
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist(addressId = null) {
      const params = { page: 1 };
      
      // 如果传入了地址ID，则添加到查询参数中
      if (addressId) {
        params.id = addressId;
      }
      
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: params,
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
         
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
    toggleLocationMenu(event) {
      if (event) {
        event.stopPropagation();
      }
      this.showLocationMenu = !this.showLocationMenu;
    },
    handleClickOutside(event) {
      const filterTrigger = this.$el.querySelector('.filter-trigger');
      const locationMenu = this.$el.querySelector('.location-menu');
      const clickedInsideMenu = locationMenu && locationMenu.contains(event.target);
      const clickedTrigger = filterTrigger && filterTrigger.contains(event.target);
      if (!clickedTrigger && !clickedInsideMenu) {
        this.showLocationMenu = false;
      }
    },
  },

  mounted() {
    if (this.$refs.scrollContainer) {
      this.containerHeight = this.$refs.scrollContainer.clientHeight;
      this.startAnimation();
    }
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  created() {
    this.checkToken();
    this.restoreCachedCountry();
    this.getBasicConfig();
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.tu_list{
  display: flex;
  flex-wrap: wrap;
  padding: 2.5vw;
  background: #1f1c1f;
  padding-top: 100px;
}

.reserve-bg {
  -webkit-text-size-adjust: 100%;
  word-wrap: break-word;
  font: 12px/1.5 "Microsoft YaHei",tahoma,arial,sans-serif;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  background: transparent;
  outline: none;
  font-family: Arial,Microsoft YaHei,sans-serif;
  margin: 0;
  padding: 0;
  border: 0;
  text-decoration: none;
  color: #f3c7a2;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 50%;
  padding: 0.5rem;
}

.content-bg {
  -webkit-text-size-adjust: 100%;
  word-wrap: break-word;
  font: 12px/1.5 "Microsoft YaHei",tahoma,arial,sans-serif;
  color: #f3c7a2;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-family: Arial,Microsoft YaHei,sans-serif;
  padding: 0;
  min-height: 4.665rem;
  height: auto;
  border-radius: 0.8rem;
  border: 0.25rem solid #766350;
  margin: 0;
  background: #212121;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,0.3);
}

.card_blur_layer{
  position: relative;
  width: 100%;
  height: 100%;
  filter: blur(8px);
  transform: scale(1.03);
}

.card_lock_overlay{
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 14, 16, 0.22);
  pointer-events: none;
}

.card_lock_icon{
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3c7a2;
  background: rgba(20, 18, 20, 0.68);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.28), inset 0 0 0 1px rgba(243, 199, 162, 0.2);
  svg{
    width: 48px;
    height: 48px;
    display: block;
  }
}

.activation_popup_mask{
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: rgba(8, 8, 8, 0.72);
  backdrop-filter: blur(8px);
}

.activation_popup{
  width: 100%;
  max-width: 560px;
  border-radius: 24px;
  padding: 36px 30px 30px;
  background: linear-gradient(180deg, #2a2528 0%, #171517 100%);
  border: 1px solid rgba(230, 185, 138, 0.38);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45);
  text-align: center;
  position: relative;
}

.activation_popup::before{
  content: "";
  position: absolute;
  left: 24px;
  right: 24px;
  top: 0;
  height: 1px;
  background: linear-gradient(90deg, rgba(230, 185, 138, 0), rgba(230, 185, 138, 0.55), rgba(230, 185, 138, 0));
}

.activation_popup_icon{
  width: 92px;
  height: 92px;
  margin: 0 auto 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3c7a2;
  background: radial-gradient(circle at center, rgba(243, 199, 162, 0.18) 0%, rgba(243, 199, 162, 0.05) 65%, rgba(243, 199, 162, 0) 100%);
  box-shadow: inset 0 0 0 1px rgba(243, 199, 162, 0.18);
  svg{
    width: 46px;
    height: 46px;
    display: block;
  }
}

.activation_popup_title{
  color: #f3c7a2;
  font-size: 34px;
  font-weight: bold;
  line-height: 1.2;
}

.activation_popup_message{
  margin-top: 16px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 24px;
  line-height: 1.6;
}

.activation_popup_actions{
  margin-top: 30px;
}

.activation_popup_button{
  min-width: 180px;
  height: 74px;
  border: none;
  border-radius: 999px;
  padding: 0 36px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #3a2a1b;
  font-size: 26px;
  font-weight: bold;
  box-shadow: 0 10px 24px rgba(220, 171, 118, 0.28);
}

.img-container {
  overflow: hidden;
  border-top-left-radius: 0.55rem;
  border-top-right-radius: 0.55rem;
  width: 100%;
}

.item_img {
  width: 102%;
  aspect-ratio: 0.7;
  object-fit: cover;
  display: block;
  margin: -1px -1px 0 -1px;
}

.corner_tag{
  position: absolute;
  right: -42px;
  top: 12px;
  font-size: 0.65rem;
  padding: 2px 40px;
  background: #efcba7;
  color: #8d5825;
  transform: rotate(45deg);
  z-index: 2;
  font-weight: bold;
}

.info_box{
  padding: 0.3rem 0.8rem;
  background: linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.name_box {
  margin-bottom: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.name {
  color: #f3c7a2;
  font-size: 0.9rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 55%;
}

.location {
  font-weight: 400;
  font-size: 16px;
  color: #4a4947;
  padding: 4px 12px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  border-radius: 10px;
  margin-left: 0;
}

.stats {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8rem;
  margin-bottom: 0;
}

.stat_item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.icon {
  width: 1rem;
  height: 1rem;
  opacity: 0.8;
}

.stat_num {
  color: #fff;
  font-size: 0.8rem;
}

.nav_box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  .x_p{
    text-align: center;
    color: #e6b98a;
    img{
      height: 76px;
    }
  }
}
.put_tit{
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before{
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii{
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  border: 1px solid #766350;
  .xx_bc{
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    justify-content: space-between;
    padding-top: 10px;
    .top_link{
      padding: 20px 10px;
    }
  }
}
.wuzii_p{
  margin: 26px 20px 16px;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u{
    color: #ccc;
  }
}
.header {
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
}

.header_left {
  display: flex;
  align-items: center;
  width: 150px;
}

.header_center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.filter-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}

.header_right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  max-width: 45%;
  flex-shrink: 0;
  padding-right: 0;
}

.img_c {
  color: #e6b98a;
  font-size: 32px;
  font-weight: bold;
}

.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}

.location-select {
  display: inline-flex;
  justify-content: flex-end;
  max-width: 100%;
}

.selected-location {
  padding: 8px 0 8px 12px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: transparent;
  color: #f3c7a2;
  font-size: 26px;
  max-width: 100%;
  white-space: nowrap;
}

.location-icon {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}

.selected-location-text {
  color: #e6b98a;
  font-weight: bold;
  margin-right: 5px;
  white-space: nowrap;
  flex-shrink: 1;
}

.filter-trigger-arrow {
  width: 20px;
  height: 20px;
  display: inline-block;
  flex-shrink: 0;
  border-right: 4px solid #e6b98a;
  border-bottom: 4px solid #e6b98a;
  transform: rotate(45deg) translateY(-2px);
  transition: transform 0.2s ease;
}

.filter-trigger-arrow.arrow-open {
  transform: rotate(-135deg) translateY(-2px);
}

.location-menu {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  background-color: #1f1c1f;
  border-top: 1px solid rgba(118, 99, 80, 0.4);
  border-bottom: 1px solid rgba(118, 99, 80, 0.4);
  z-index: 9;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  width: 100%;
}

.location-menu.location-menu-open {
  max-height: 760px;
}

.location-item-container {
  padding: 24px 20px 28px;
  max-width: 900px;
  margin: 0 auto;
}

.filter_section + .filter_section{
  margin-top: 18px;
}

.filter_label{
  color: #f1e0cf;
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 12px;
}

.filter_tab_group{
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.filter_tab{
  min-width: 128px;
  height: 52px;
  padding: 0 20px;
  border-radius: 18px;
  border: 1px solid rgba(238, 198, 162, 0.24);
  background: rgba(39, 39, 39, 0.96);
  color: rgba(255, 255, 255, 0.7);
  font-size: 24px;
}

.filter_tab.active{
  color: #f3c7a2;
  border-color: rgba(243, 199, 162, 0.6);
  box-shadow: inset 0 0 0 1px rgba(243, 199, 162, 0.18);
}

.distance_tab{
  min-width: 112px;
}

.age_range_box{
  display: flex;
  align-items: center;
  gap: 16px;
}

.age_value{
  color: #f1d0ad;
  font-size: 26px;
  min-width: 32px;
  text-align: center;
}

.age_slider_box{
  flex: 1;
  position: relative;
  height: 36px;
}

.age_slider_track,
.age_slider_active{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 6px;
  border-radius: 999px;
}

.age_slider_track{
  left: 0;
  right: 0;
  background: rgba(243, 199, 162, 0.2);
}

.age_slider_active{
  background: linear-gradient(90deg, #efcba7, #dcab76);
}

.age_range_input{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 36px;
  margin: 0;
  background: transparent;
  appearance: none;
  pointer-events: none;
}

.age_range_input::-webkit-slider-runnable-track{
  height: 6px;
  background: transparent;
}

.age_range_input::-webkit-slider-thumb{
  appearance: none;
  width: 24px;
  height: 24px;
  margin-top: -9px;
  border-radius: 50%;
  border: 2px solid #f4d4b1;
  background: linear-gradient(180deg, #f7d8b8, #ddb07c);
  box-shadow: 0 4px 10px rgba(220, 171, 118, 0.35);
  pointer-events: auto;
}

.filter_select_box{
  position: relative;
}

.filter_select_box::after{
  content: "";
  position: absolute;
  right: 18px;
  top: 50%;
  width: 10px;
  height: 10px;
  border-right: 2px solid rgba(243, 199, 162, 0.72);
  border-bottom: 2px solid rgba(243, 199, 162, 0.72);
  transform: translateY(-70%) rotate(45deg);
  pointer-events: none;
}

.filter_select{
  width: 100%;
  height: 56px;
  border-radius: 16px;
  border: 1px solid rgba(238, 198, 162, 0.24);
  background: rgba(39, 39, 39, 0.96);
  color: #f3c7a2;
  font-size: 24px;
  padding: 0 44px 0 18px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  box-shadow: none;
}

.filter_select:focus,
.filter_select:active{
  outline: none;
  box-shadow: none;
  border-color: rgba(238, 198, 162, 0.24);
}

.filter_select::-ms-expand{
  display: none;
}

.filter_select option{
  background: #2b2a2a;
  color: #f3c7a2;
}

.filter_actions{
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.filter_action_button{
  flex: 1;
  height: 60px;
  border-radius: 18px;
  font-size: 26px;
  font-weight: bold;
}

.reset_button{
  border: 1px solid rgba(238, 198, 162, 0.16);
  background: rgba(39, 39, 39, 0.96);
  color: rgba(255, 255, 255, 0.68);
}

.search_button{
  border: none;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #3a2a1b;
}

.tu_list {
  display: flex;
  flex-wrap: wrap;
  padding: 2.5vw;
  background: #1f1c1f;
  padding-top: 100px;
}

.register-btn {
  color: #f3c7a2;
  cursor: pointer;
  font-size: 18px;
}

.register-btn:hover {
  color: #e6b98a;
}
</style>
